module.exports = __webpack_public_path__ + "static/media/texas_cyber.b61797c9.png";